import { getData, URLs } from '@common/api';
import * as Product from '@common/models/Product';
import { Context as ContextInterface } from '@common/utils/constants';
import { PayloadAction } from '@reduxjs/toolkit';
import { call, ForkEffect, put, select, takeEvery } from 'redux-saga/effects';

import {
  fetchSearchFailureNew,
  fetchSearchRequestNew,
  FetchSearchRequestPayloadType,
  fetchSearchSuccessNew,
} from './slice';

function* fetchSearchSaga({ payload: { queryParams, storeKey } }: PayloadAction<FetchSearchRequestPayloadType>) {
  try {
    const context: ContextInterface = yield select((store) => {
      return store.context.context;
    });
    const storeUrl = `https://${context.MERCHANT_HOSTNAME}`;
    const { data } = yield call(() => getData({ url: URLs.GET_SEARCH_NEW, params: queryParams }));
    data.results = data.results?.map((process) => Product.processResponse(process, { storeUrl }));
    data.meta = {
      totalHits: data?.count,
    };
    yield put(fetchSearchSuccessNew({ search: data, queryParams, storeKey }));
  } catch (e) {
    yield put(fetchSearchFailureNew({ storeKey, error: 'Request failed with: ' + e }));
  }
}

export default function* searchSagas(): Generator<ForkEffect<never>, void, unknown> {
  yield takeEvery(fetchSearchRequestNew.type, fetchSearchSaga);
}
